import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { HttpClient } from '@angular/common/http';
import { AccountService } from './account.service';
import { catchError, Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NeolabSyncService {
  constructor(private api: BaseApiService
  ) { }


  sync(params: any): Observable<any> {
    return this.api
      .post('neolab-sync/sync', params)
      .pipe(catchError(this.handleError<[]>(`neolab-sync/sync`)));
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      const errorMsg = `${operation} failed: ${error.message}`;
      return throwError(error);
    };
  }
}
